import * as React from "react";
const SvgChartHistogram = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4418_4160)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.5 22H5.5C4.70435 22 3.94129 21.6839 3.37868 21.1213C2.81607 20.5587 2.5 19.7956 2.5 19V1C2.5 0.734784 2.39464 0.48043 2.20711 0.292893C2.01957 0.105357 1.76522 0 1.5 0C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1L0.5 19C0.501588 20.3256 1.02888 21.5964 1.96622 22.5338C2.90356 23.4711 4.17441 23.9984 5.5 24H23.5C23.7652 24 24.0196 23.8946 24.2071 23.7071C24.3946 23.5196 24.5 23.2652 24.5 23C24.5 22.7348 24.3946 22.4804 24.2071 22.2929C24.0196 22.1054 23.7652 22 23.5 22Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.5 20C6.76521 20 7.01957 19.8946 7.2071 19.7071C7.39464 19.5196 7.5 19.2652 7.5 19V12C7.5 11.7348 7.39464 11.4804 7.2071 11.2929C7.01957 11.1054 6.76521 11 6.5 11C6.23478 11 5.98043 11.1054 5.79289 11.2929C5.60536 11.4804 5.5 11.7348 5.5 12V19C5.5 19.2652 5.60536 19.5196 5.79289 19.7071C5.98043 19.8946 6.23478 20 6.5 20Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 10V19C10.5 19.2652 10.6054 19.5196 10.7929 19.7071C10.9804 19.8946 11.2348 20 11.5 20C11.7652 20 12.0196 19.8946 12.2071 19.7071C12.3947 19.5196 12.5 19.2652 12.5 19V10C12.5 9.73478 12.3947 9.48043 12.2071 9.29289C12.0196 9.10536 11.7652 9 11.5 9C11.2348 9 10.9804 9.10536 10.7929 9.29289C10.6054 9.48043 10.5 9.73478 10.5 10Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.5 13V19C15.5 19.2652 15.6054 19.5196 15.7929 19.7071C15.9804 19.8946 16.2348 20 16.5 20C16.7652 20 17.0196 19.8946 17.2071 19.7071C17.3947 19.5196 17.5 19.2652 17.5 19V13C17.5 12.7348 17.3947 12.4804 17.2071 12.2929C17.0196 12.1054 16.7652 12 16.5 12C16.2348 12 15.9804 12.1054 15.7929 12.2929C15.6054 12.4804 15.5 12.7348 15.5 13Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M20.5 9V19C20.5 19.2652 20.6054 19.5196 20.7929 19.7071C20.9804 19.8946 21.2348 20 21.5 20C21.7652 20 22.0196 19.8946 22.2071 19.7071C22.3947 19.5196 22.5 19.2652 22.5 19V9C22.5 8.73478 22.3947 8.48043 22.2071 8.29289C22.0196 8.10536 21.7652 8 21.5 8C21.2348 8 20.9804 8.10536 20.7929 8.29289C20.6054 8.48043 20.5 8.73478 20.5 9Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.49979 8.99992C6.76498 8.99986 7.01929 8.89447 7.20679 8.70692L10.7928 5.12092C10.9834 4.93934 11.2365 4.83806 11.4998 4.83806C11.763 4.83806 12.0162 4.93934 12.2068 5.12092L14.3788 7.29292C14.9414 7.85533 15.7043 8.17128 16.4998 8.17128C17.2953 8.17128 18.0582 7.85533 18.6208 7.29292L24.2068 1.70692C24.3889 1.51832 24.4897 1.26571 24.4875 1.00352C24.4852 0.741321 24.38 0.490508 24.1946 0.3051C24.0092 0.119692 23.7584 0.0145233 23.4962 0.0122448C23.234 0.00996641 22.9814 0.110761 22.7928 0.292919L17.2068 5.87792C17.0193 6.06539 16.765 6.17071 16.4998 6.17071C16.2346 6.17071 15.9803 6.06539 15.7928 5.87792L13.6208 3.70692C13.0582 3.14451 12.2953 2.82856 11.4998 2.82856C10.7043 2.82856 9.94137 3.14451 9.37879 3.70692L5.79279 7.29292C5.65298 7.43277 5.55777 7.61093 5.5192 7.80489C5.48064 7.99884 5.50044 8.19987 5.57611 8.38257C5.65178 8.56527 5.77992 8.72144 5.94433 8.83132C6.10874 8.94121 6.30204 8.99988 6.49979 8.99992Z",
      fill: "#1B1C1D"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4418_4160" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0.5)" })))
);
export default SvgChartHistogram;
